import { create } from 'zustand';
import { User } from '@supabase/supabase-js';

type UserType = 'artist' | 'user' | 'admin';

interface AuthState {
  user: User | null;
  userType: UserType | null;
  isLoading: boolean;
  setUser: (user: User | null) => void;
  setUserType: (userType: UserType | null) => void;
  setIsLoading: (isLoading: boolean) => void;
  reset: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  userType: null,
  isLoading: true,

  setUser: (user) => {
    const userType = user?.user_metadata?.user_type as UserType | null;
    set({ user, userType });
  },

  setUserType: (userType) => set({ userType }),

  setIsLoading: (isLoading) => set({ isLoading }),

  reset: () => set({ user: null, userType: null, isLoading: false }),
}));
